import type {Variants} from 'framer-motion';

export const HintAnimation: Variants = {
    enter: {height: 'auto'},
    exit: {height: 0},
    initial: {height: 0}
};